import { render, staticRenderFns } from "./CreateManualInvoicePage.vue?vue&type=template&id=33f3fe6a&scoped=true"
import script from "./CreateManualInvoicePage.vue?vue&type=script&lang=js"
export * from "./CreateManualInvoicePage.vue?vue&type=script&lang=js"
import style0 from "./CreateManualInvoicePage.vue?vue&type=style&index=0&id=33f3fe6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f3fe6a",
  null
  
)

export default component.exports